
import { type Site } from "~/stores";

/**
 * Makes sure path starts with slash and doesn't end one.
 * @param path 
 * @returns 
 */
export function asPathSegment (path: string) {
  return (path.startsWith('/') ? path : '/' + path).replace(/\/$/, '');
}

export function viaCDN (path: string, site: Pick<Site, 'cdn_host'>) {
  if (path.startsWith('http')) return path;
  const cdn = site.cdn_host.replace(/\/$/, '')
  return cdn + '/' + path.replace(/^\//, '');
}
